import { render, staticRenderFns } from "./ModuleV3.vue?vue&type=template&id=11388cba&scoped=true&"
import script from "./ModuleV3.vue?vue&type=script&lang=js&"
export * from "./ModuleV3.vue?vue&type=script&lang=js&"
import style0 from "./ModuleV3.vue?vue&type=style&index=0&id=11388cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11388cba",
  null
  
)

export default component.exports